/**
 * 卡包视觉主题配置
 * 统一管理卡包的渐变、发光、动画参数
 */

import type { PackId } from '../engine/types'

// Pack cover images
import packUserInterview from '../assets/images/packs/pack-user-interview.webp'
import packExpertInterview from '../assets/images/packs/pack-expert-interview.webp'
import packIndustryReport from '../assets/images/packs/pack-industry-report.webp'
import packCompetitorAnalysis from '../assets/images/packs/pack-competitor-analysis.webp'

export const PACK_IMAGE: Record<PackId, string> = {
  user_interview: packUserInterview,
  expert_interview: packExpertInterview,
  industry_report: packIndustryReport,
  competitor_analysis: packCompetitorAnalysis,
}

export type PackTheme = {
  gradient: string; glow: string; border: string; accent: string
  shimmerColor: string; edgeHighlight: string
  // per-pack foil animation
  sweepDuration: number   // seconds
  sweepAngle: number      // shimmer gradient angle (deg)
  pulseDuration: number   // edge pulse cycle (seconds)
  pulseDelay: number      // edge pulse offset (seconds)
  textureAngles: [number, number, number]  // 3-layer brushed metal angles
  textureSpacings: [number, number, number] // 3-layer line spacings (px)
  spotSize: number        // mouse follow spot radius (px)
}

export const PACK_THEME: Record<PackId, PackTheme> = {
  user_interview: {
    gradient: 'linear-gradient(145deg, #1A3D5C 0%, #3A7A9A 15%, #1E4A6A 30%, #5A9FBF 50%, #1A3D5C 65%, #2A6A8A 80%, #1A3D5C 100%)',
    glow: 'rgba(124,175,194,0.4)',
    border: '#5A9FBF',
    accent: '#7CAFC2',
    shimmerColor: 'rgba(180,220,240,0.4)',
    edgeHighlight: 'rgba(130,200,230,0.6)',
    sweepDuration: 3.5, sweepAngle: 105, pulseDuration: 3, pulseDelay: 0,
    textureAngles: [90, 0, 135], textureSpacings: [3, 5, 7],
    spotSize: 80,
  },
  expert_interview: {
    gradient: 'linear-gradient(145deg, #5C1A3D 0%, #9A3A6A 15%, #6A1E4A 30%, #BF5A8F 50%, #5C1A3D 65%, #8A2A6A 80%, #5C1A3D 100%)',
    glow: 'rgba(212,132,154,0.4)',
    border: '#BF5A7F',
    accent: '#D4849A',
    shimmerColor: 'rgba(240,180,200,0.4)',
    edgeHighlight: 'rgba(230,140,180,0.6)',
    sweepDuration: 4.2, sweepAngle: 115, pulseDuration: 3.5, pulseDelay: 0.8,
    textureAngles: [80, 10, 145], textureSpacings: [4, 6, 8],
    spotSize: 70,
  },
  industry_report: {
    gradient: 'linear-gradient(145deg, #1A4C2A 0%, #3A8A4A 15%, #1E5A32 30%, #5ABF6F 50%, #1A4C2A 65%, #2A7A3A 80%, #1A4C2A 100%)',
    glow: 'rgba(125,175,139,0.4)',
    border: '#5ABF6F',
    accent: '#7DAF8B',
    shimmerColor: 'rgba(180,240,200,0.4)',
    edgeHighlight: 'rgba(140,220,160,0.6)',
    sweepDuration: 4.8, sweepAngle: 95, pulseDuration: 4, pulseDelay: 1.5,
    textureAngles: [100, 170, 125], textureSpacings: [3, 4, 9],
    spotSize: 90,
  },
  competitor_analysis: {
    gradient: 'linear-gradient(145deg, #5C4C1A 0%, #9A8A3A 15%, #6A5A1E 30%, #BFA55A 50%, #5C4C1A 65%, #8A7A2A 80%, #5C4C1A 100%)',
    glow: 'rgba(201,169,110,0.4)',
    border: '#BFA55A',
    accent: '#C9A96E',
    shimmerColor: 'rgba(240,220,160,0.4)',
    edgeHighlight: 'rgba(230,200,130,0.6)',
    sweepDuration: 3.8, sweepAngle: 125, pulseDuration: 2.8, pulseDelay: 2.2,
    textureAngles: [70, 20, 155], textureSpacings: [5, 7, 6],
    spotSize: 75,
  },
}
